import { Box, Button, Typography } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { TGetServicesCollectionItem } from "../../../../../../api/service/service.types";
import BadgeIcon from "../../../../../../assets/images/iconos/badge.png";
import ZohoIcon from "../../../../../../assets/images/iconos/zoho.png";
import cuideoTheme from "../../../../../../containers/themes/defaultTheme";
import { APP_START_PAGE } from "../../../../../../util/defaults/app";
import useStandarizedServiceTitle from "../../../../../../util/Service/useStandarizedServiceTitle";
import ServiceType from "../../../../components/ServiceType";
import ServiceExpressTag from "../ServiceExpressTag";
import ServicePlanTag from "../ServicePlanTag";

const StyledWrapper = styled(Box)`
  background-color: #f5f5f5;
  padding: 0.5rem 1rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 0.125rem solid #ddd;
`;

const StyledSection = styled(Box)`
  padding: 0 0.5rem;
`;

const StyledLink = styled(Link)`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  text-decoration: none;
  color: ${cuideoTheme.palette.primary.main};
  opacity: 0.5;
`;
const StyledArrowBackIosIcon = styled(ArrowBackIosIcon)`
  font-size: 1.5rem;
`;

const StyledDivider = styled.div`
  height: 2rem;
  width: 1px;
  background-color: ${cuideoTheme.palette.primary.main};
  opacity: 0.25;
`;

const StyledGrowSection = styled(Box)`
  padding: 0 0.5rem;
  flex-grow: 1;
`;

const StyledFirstRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledFirstRowLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledRowSection = styled.div`
  margin: 0 0.5rem;
`;

const StyledServiceStatus = styled(Typography)`
  color: ${cuideoTheme.palette.primary.light};
  font-size: 0.75rem;
`;

const StyledServiceName = styled(Typography)`
  color: rgb(246, 74, 105);
  font-size: 0.75rem;
`;

const StyledActionLink = styled(Button)`
  text-decoration: none;
  margin-left: 0.25rem;
  padding: 0.25rem;

  &:hover {
    background-color: rgba(0, 72, 120, 0.25);
  }
`;

const StyledActionIcon = styled.img`
  display: block;
  width: 0.875rem;
  height: 0.875rem;
  margin-right: 0.5rem;
`;
const StyledActionLinkText = styled(Typography)`
  font-size: 0.75rem;
  text-transform: none;
`;

const StyledFirstRowRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledTriItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledTriIcon = styled.img`
  width: 0.875rem;
  height: 0.875rem;
  display: block;
  margin-right: 0.5rem;
`;

const StyledTriDataWrapper = styled.div``;

const StyledTriData = styled(Typography)`
  color: ${cuideoTheme.palette.primary.main};
  font-size: 0.75rem;
  font-weight: 400;
  margin: 0;
`;

const StyledSecondRow = styled(Box)`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

const StyledSecondRowLeft = styled(Box)``;

const StyledTitleWrapper = styled(Box)`
  margin: 0 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledTitle = styled(Typography)`
  font-size: 1.55rem;
  font-weight: 700;
  letter-spacing: normal;
  font-stretch: normal;
  line-height: 1;
  color: #002740;
  padding-bottom: 0.75rem;
`;

export const StyledBottomInfoLine = styled.div``;

interface IServiceHeaderProps {
  service: TGetServicesCollectionItem;
}

const ServiceHeader = (props: IServiceHeaderProps) => {
  const { service } = props;
  const serviceTitle = useStandarizedServiceTitle(service);
  const history = useHistory();

  return (
    <StyledWrapper>
      <StyledSection>
        <StyledLink
          to={APP_START_PAGE}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            if (history.action !== "POP") {
              history.goBack();
            }
          }}
        >
          <StyledArrowBackIosIcon />
        </StyledLink>
      </StyledSection>
      <StyledDivider />
      <StyledGrowSection>
        <StyledFirstRow>
          <StyledFirstRowLeft>
            <StyledRowSection>
              <ServiceType
                serviceType={service.Tipo_de_Servicio}
                serviceDealType={service.Tipo_de_Trato}
              />
            </StyledRowSection>
            <StyledRowSection>
              <ServicePlanTag service={service} />
            </StyledRowSection>
            <StyledRowSection>
              <ServiceExpressTag service={service} />
            </StyledRowSection>
            <StyledRowSection>
              <StyledServiceName>{service.Name}</StyledServiceName>
            </StyledRowSection>
            <StyledRowSection>
              <StyledServiceStatus>
                <FormattedMessage
                  id="ServiceHeader.Status"
                  defaultMessage="Estado: {status}"
                  values={{ status: service.Estado_Servicio }}
                />
              </StyledServiceStatus>
            </StyledRowSection>
            <StyledRowSection>
              <StyledActionLink
                color="primary"
                onClick={() => {
                  window.open(
                    `https://crm.zoho.com/crm/org638326163/tab/CustomModule17/${service.zohoId}`
                  );
                }}
              >
                <StyledActionIcon src={ZohoIcon} />
                <StyledActionLinkText>
                  <FormattedMessage
                    id="ContractHeader.ViewInZoho"
                    defaultMessage="Ver en Zoho"
                  />
                </StyledActionLinkText>
              </StyledActionLink>
            </StyledRowSection>
          </StyledFirstRowLeft>
          <StyledFirstRowRight>
            <StyledTriItem>
              <StyledTriIcon src={BadgeIcon} />
              <StyledTriDataWrapper>
                <StyledTriData>{service.ownerName}</StyledTriData>
              </StyledTriDataWrapper>
            </StyledTriItem>
          </StyledFirstRowRight>
        </StyledFirstRow>
        <StyledSecondRow>
          <StyledSecondRowLeft>
            <StyledTitleWrapper>
              <StyledTitle>{serviceTitle}</StyledTitle>
            </StyledTitleWrapper>
          </StyledSecondRowLeft>
        </StyledSecondRow>
      </StyledGrowSection>
    </StyledWrapper>
  );
};

export default ServiceHeader;
